export default "__VITE_ASSET__CJ2MFP8q__"